import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-loading-skeleton/dist/index.js");
